import React from "react";
import {ListaMessaggi} from "./ListaMessaggi";
import {Box, CircularProgress} from "@mui/material";

export const MessaggiDaApprovare = ({domandeCartomante, data, loading, refetch}) => {

    return (
        <Box>
            {loading ? <CircularProgress/> : <ListaMessaggi domandeCartomante={domandeCartomante} stato={'daApprovare'} messages={data} refetch={refetch}/>}
        </Box>
    )
}
